import '@drayalliance/com-web-styleguide-react/lib/styles/v1';
import './style.css';
import C from './component';

export default C;
